module.exports = __webpack_public_path__ + "static/media/check-bullet-list.b5d424cc.svg";